export const parseJwtToken = (token = '') => {
  try {
    return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
  } catch (_error) {
    return null;
  }
};
